import { StationArbeitsbereichCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/StationArbeitsbereichCard';
import { renderRotationsplaeneByMitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/renderRotationsplaeneByMitarbeiter';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

export function Kalender({
  view,
}: {
  view: 'mitarbeiter' | 'arbeitsbereiche';
}) {
  const {
    store: {
      data: {
        planung: { rotationsplaene, rotationsplaeneByArbeitsbereiche },
      },
      ui: {
        kalender: { currentStartOfWeek, currentEndOfWeek },
      },
    },
  } = useRotationsplanFeatureContext();

  return (
    <div className="flex flex-col gap-4">
      {view === 'arbeitsbereiche'
        ? rotationsplaeneByArbeitsbereiche.map((arbeitsbereich) =>
            arbeitsbereich.stationen
              ?.filter(
                (kalenderStation) =>
                  dayjs(kalenderStation.station.von).isSameOrBefore(
                    currentEndOfWeek,
                  ) &&
                  dayjs(kalenderStation.station.bis).isSameOrAfter(
                    currentStartOfWeek,
                  ),
              )
              .map((kalenderStation) => {
                return (
                  <StationArbeitsbereichCard
                    key={kalenderStation.station.id}
                    arbeitsbereich={arbeitsbereich}
                    kalenderStation={kalenderStation}
                  />
                );
              }),
          )
        : renderRotationsplaeneByMitarbeiter({
            currentEndOfWeek,
            currentStartOfWeek,
            rotationsplaene,
          })}
    </div>
  );
}
